import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
import { LoadingAnimation } from '../components/Analysis/LoadingAnimation';
export function LoadingPage() {
  const navigate = useNavigate();
  // For demo purposes only - simulate API call completion
  useEffect(() => {
    const timer = setTimeout(() => {
      // In a real scenario, this would be handled by the API response
      // navigate('/results')
    }, 8000);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8987" data-mp="10xlqg0slpwuj">
      <WebsiteHeader data-id="element-8988" data-mp="15x83oa8fjd3c" />

      <main className="flex-1 flex flex-col items-center justify-center px-6 pb-20" data-id="element-8989" data-mp="1auhr5kc9deoj">
        <div className="w-full max-w-lg bg-white rounded-3xl shadow-xl shadow-purple-900/5 border border-purple-100 p-8 md:p-12 relative overflow-hidden" data-id="element-8990" data-mp="2ha0u9hphhvht">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 via-purple-500 to-blue-500" data-id="element-8991" data-mp="1x89h89ymxe1h"></div>
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-purple-50 rounded-full blur-3xl opacity-50" data-id="element-8992" data-mp="1t6o88zp81jwk"></div>
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-red-50 rounded-full blur-3xl opacity-50" data-id="element-8993" data-mp="1o6jnuyl70512"></div>

          <LoadingAnimation data-id="element-8994" data-mp="1j8i6qj7bufs8" />
        </div>
      </main>
    </div>;
}